import { Component, OnInit } from '@angular/core';
import { PhotoEditorCanvasService } from '../../photo-editor-canvas/photo-editor-canvas.service';
import { tap } from 'rxjs/internal/operators/tap';

@Component({
  selector: 'app-photo-editor-tools-font-color',
  templateUrl: './photo-editor-tools-font-color.component.html',
  styleUrls: ['./photo-editor-tools-font-color.component.scss']
})
export class PhotoEditorToolsFontColorComponent implements OnInit {

  showColors: boolean;
  currentColor;
  colors = [
    {
      id: 'white',
      hex: '#FFFFFF'
    },
    {
      id: 'lightgray',
      hex: '#CCCCCC'
    },
    {
      id: 'gray',
      hex: '#888888'
    },
    {
      id: 'darkgray',
      hex: '#222222'
    },
    {
      id: 'black',
      hex: '#000000'
    },
    {
      id: 'darkblue',
      hex: '#00008B'
    },
    {
      id: 'blue',
      hex: '#0000FF'
    },
    {
      id: 'blueviolet',
      hex: '#8A2BE2'
    },
    {
      id: 'deepskyblue',
      hex: '#00BFFF'
    },
    {
      id: 'turquoise',
      hex: '#40E0D0'
    },
    {
      id: 'teal',
      hex: '#008080'
    },
    {
      id: 'pink',
      hex: '#FFC0CB'
    },
    {
      id: 'yellow',
      hex: '#FFFF00'
    },
    {
      id: 'orange',
      hex: '#FFA500'
    },
    {
      id: 'brown',
      hex: '#A52A2A'
    },
    {
      id: 'darkred',
      hex: '#8B0000'
    },
    {
      id: 'red',
      hex: '#FF0000'
    },
    {
      id: 'yellowgreen',
      hex: '#9ACD32'
    },
    {
      id: 'green',
      hex: '#008000'
    },
    {
      id: 'aquamarine',
      hex: '#7FFFD4'
    },
    {
      id: 'indigo',
      hex: '#4B0082'
    },
    {
      id: 'sienna',
      hex: '#A0522D'
    },
    {
      id: 'silver',
      hex: '#C0C0C0'
    },
    {
      id: 'tomato',
      hex: '#FF6347'
    },
    {
      id: 'palevioletred',
      hex: '#DB7093'
    },
    {
      id: 'gold',
      hex: '#FFD700'
    },
    {
      id: 'firebrick',
      hex: '#B22222'
    },
    {
      id: 'khaki',
      hex: '#F0E68C'
    },
    {
      id: 'seagreen',
      hex: '#2E8B57'
    },
    {
      id: 'darkorange',
      hex: '#FF8C00'
    },
    {
      id: 'darkslategrey',
      hex: '#2F4F4F'
    },
    {
      id: 'cyan',
      hex: '#00FFFF'
    }
  ];

  constructor(private photoEditorCanvasService: PhotoEditorCanvasService) { }

  ngOnInit() {
    this._listenSelectFontColor();
    this._listenShowSelectFontColor();
  }

  public toggleColors() {
    this.showColors = !this.showColors;
  }

  public setColor(color) {
    this.photoEditorCanvasService.selectFontColor(color);
  }

  public _listenSelectFontColor() {
    this.photoEditorCanvasService.listenSelectFontColor().pipe(
      tap(res => this.currentColor = res),
      tap(res => this.photoEditorCanvasService.showSelectFontColor(false))
    ).subscribe();
  }
  public _listenShowSelectFontColor() {
    this.photoEditorCanvasService.listenShowSelectFontColor().pipe(
      tap(res => this.showColors = res)
    ).subscribe();
  }
}
